import React from "react";
import { IconContainer, LabelConatiners, Main } from "./styles";

import RadioButtonOff from "../../img/icons/radio-button-off.svg";
import RadioButtonOn from "../../img/icons/radio-button-on.svg";

const RadioCardSelect = ({
  icon,
  label,
  sublabel,
  selected,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  sublabel?: string;
  selected?: boolean;
  onClick: () => void;
}) => {
  return (
    <Main selected={selected} onClick={onClick}>
      <IconContainer selected={selected}>{icon}</IconContainer>
      <LabelConatiners>
        <span>{label}</span>
        <span>{sublabel}</span>
      </LabelConatiners>
      {selected ? (
        <RadioButtonOn className="radioButton" />
      ) : (
        <RadioButtonOff className="radioButton" />
      )}
    </Main>
  );
};

export default RadioCardSelect;
